import {
    GETSUBMODULEMASTERFORADMIN_SUCCESS,
    GETSUBMODULEMASTERFORADMIN_FAILED,
    RESET_GETSUBMODULEMASTERFORADMIN,
    LOADING_GETSUBMODULEMASTERFORADMIN,
    NETWORK_ERROR_GETSUBMODULEMASTERFORADMIN,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETSUBMODULEMASTERFORADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case GETSUBMODULEMASTERFORADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case GETSUBMODULEMASTERFORADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_GETSUBMODULEMASTERFORADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_GETSUBMODULEMASTERFORADMIN:
            return (state = initialState);
        default:
            return state;
    }
};
